import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { useParams } from "react-router-dom";
import Select from "react-select";

function DeliveryChallanServiceItemAdd({ sales_order_id }) {
  console.log(sales_order_id);

  const [selectedItems, setSelectedItems] = useState([]);
  const [itemCustomerList, setItemCustomerList] = useState([]);
  const [costPrice, setCostPrice] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const { customer_id } = useParams();
  const token = sessionStorage.getItem("token");

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getItemCustomer();
  }, [searchInput, customer_id]);

  const getItemCustomer = async () => {
    try {
      const response = await axios.post(
        "/api/purple-fusion/itemcustomer/getforSearch",
        { customer_id, search_parameter: searchInput },
        headers
      );
      setItemCustomerList(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const itemsDetailsGetByID = (iId) => {
    const obj = {
      item_detail_id: iId,
      sales_order_id: sales_order_id,
    };
    console.log(obj);

    axios
      .post(
        "/api/purple-fusion/salesorderitem/getitemdetaisforsalesorder",
        obj,
        headers
      )
      .then((response) => {
        setCostPrice(
          response.data.length > 0 ? response.data[0].cost_price : 0
        );
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const options = itemCustomerList.map((item) => ({
    ...item,
    label: `${item.item_name} - ${item.code} - ${item.code_op || ""}`,
    value: item.item_detail_id,
  }));

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedItems((prevItems) => [
        ...prevItems,
        {
          ...selectedOption,
        },
      ]);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedItems = [...selectedItems];
    updatedItems[index][field] = parseFloat(value) || 0;

    // Calculate new values
    const itemAmount =
      updatedItems[index].quantity * updatedItems[index].cost_price;
    const sgstAmount = (itemAmount * updatedItems[index].sgst) / 100;
    const cgstAmount = (itemAmount * updatedItems[index].cgst) / 100;
    const igstAmount = (itemAmount * updatedItems[index].igst) / 100;
    const totalTax = sgstAmount + cgstAmount + igstAmount;
    const finalAmount = itemAmount + totalTax;

    // Update calculated values in state
    updatedItems[index].item_amount = itemAmount.toFixed(2);
    updatedItems[index].total_tax = totalTax.toFixed(2);
    updatedItems[index].final_amount = finalAmount.toFixed(2);

    setSelectedItems(updatedItems);
  };

  const handleDelete = (index) => {
    setSelectedItems(selectedItems.filter((_, i) => i !== index));
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-2">Select Item</h2>
      <Select
        options={options}
        onChange={(selectedOption, e) => {
          handleSelectChange(selectedOption);
          itemsDetailsGetByID(selectedOption.value);
        }}
        className="w-1/2 text-xs"
        onInputChange={(input) => setSearchInput(input)}
      />

      {selectedItems.length > 0 && (
        <table className="w-full border mt-4">
          <thead>
            <tr className="bg-gray-200 text-xs">
              <th className="border px-2 py-1">Name</th>
              <th className="border px-2 py-1">Code</th>
              <th className="border px-2 py-1">Quantity</th>
              <th className="border px-2 py-1">Cost Price</th>
              <th className="border px-2 py-1">Item Amount</th>
              <th className="border px-2 py-1">SGST (%)</th>
              <th className="border px-2 py-1">CGST (%)</th>
              <th className="border px-2 py-1">IGST (%)</th>
              <th className="border px-2 py-1">Total Tax Amount</th>
              <th className="border px-2 py-1">Final Amount</th>
              <th className="border px-2 py-1">Action</th>
            </tr>
          </thead>
          <tbody>
            {selectedItems.map((item, index) => (
              <tr key={index} className="border text-xs">
                <td className="border px-2 py-1">{item?.item_name}</td>
                <td className="border px-2 py-1">{item?.code || ""}</td>
                <td className="border px-2 py-1">
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) =>
                      handleInputChange(index, "quantity", e.target.value)
                    }
                    className="border p-1 w-16 text-xs"
                  />
                </td>
                <td className="border px-2 py-1">
                  <input
                    type="number"
                    value={item.cost_price}
                    onChange={(e) =>
                      handleInputChange(index, "cost_price", e.target.value)
                    }
                    className="border p-1 w-16 text-xs"
                  />
                </td>
                <td className="border px-2 py-1">{item.item_amount}</td>
                <td className="border px-2 py-1">{item.sgst_percentage}</td>
                <td className="border px-2 py-1">{item.cgst_percentage}</td>
                <td className="border px-2 py-1">{item.igst_percentage}</td>
                <td className="border px-2 py-1">{item.total_tax}</td>
                <td className="border px-2 py-1">{item.final_amount}</td>
                <td className="border px-2 py-1 text-center">
                  <button
                    onClick={() => handleDelete(index)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
                    type="button"
                  >
                    <MdDelete />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default DeliveryChallanServiceItemAdd;
